<template>
  <div>
    <div class="box1200 margin-bottom-20">
      <public-header></public-header>
      <div class="height60"></div>
      <div class="introduce white-bg shadow margin-top-20">
        <h3 class="title"><i>企业信息</i></h3>
        <div class="info flex align-items">
          <div class="logo margin-right-20"><img src="@/assets/images/logo.jpg"></div>
          <div class="text">
            <p class="item">
              <span class="margin-right-10">企业名称</span>
              <span>梅州市艺博网络科技有限公司</span>
            </p>
            <p class="item">
              <span class="margin-right-10">企业地址</span>
              <span>梅州市创杰金融中心</span>
            </p>
            <p class="item">
              <span class="margin-right-10">企业电话</span>
              <span>0753-2354999</span>
            </p>
            <p class="tags flex">
              <span class="radius">认证商家</span>
              <span class="radius">企业会员</span>
            </p>
          </div>
        </div>
        <h3 class="title"><i>企业简介</i></h3>
        <div class="about">梅州市艺博网络科技有限公司，我市电子商务行业领军代表，作为深扎根于梅州市本土的互联网新媒体公司，致力于为梅州本地中小企业提供有价值的互联网营销及媒体运营策划方案，帮助中小企业连接移动互联网，培养我市互联网精英人才。 多年专注企业诊断、品牌规划、宣传创意策划、整合传播、媒体平台运营、网站搭建及开发、APP研发、电子商务培训、微营销活动策划等等服务。自创办以来帮助本地300多家企业建立移动营销平台，共开展20多场公益培训讲座，服务人次达上万人次。 旗下拥有梅州年轻人都爱看的自媒体平台-最潮梅州，本地最大的综合门户-梅州信息港，以及共享个人流量的同城营销推广服务平台-小橙达人三大平台。</div>
        <h3 class="title"><i>企业照片</i></h3>
        <div class="pic flex">
          <span v-for="item in pics" :key="item.id">
            <img :src="item.imgUrl" class="img">
          </span>
        </div>
      </div>
    </div>
    <public-footer></public-footer>
  </div>
</template>
<script>
import PublicHeader from '@/components/Header'
import PublicFooter from '@/components/Footer'
export default {
  name: 'Introduce',
  components: {
    PublicHeader,
    PublicFooter
  },
  data () {
    return {
      pics: [
        { imgUrl: 'http://img.xiaochengdaren.com/2019061886431.jpg' },
        { imgUrl: 'http://img.xiaochengdaren.com/2019061886431.jpg' }
      ]
    }
  }
}
</script>
<style scoped>
  .introduce{padding:20px 0;}
  .introduce .title i{border-left:3px #fe9539 solid;padding-left:17px;font-size: 16px;margin-top:10px;}
  .introduce .info{padding:20px;}
  .introduce .info .logo img{width:150px;height:150px;border:1px #eee solid;border-radius:5px;}
  .introduce .info .text{font-size:14px;line-height:36px;}
  .introduce .info .text .tags{margin-top:5px;}
  .introduce .info .text .tags span{color: #e6a23c;border:1px #faecd8 solid;background: #fdf6ec;height:32px;line-height:32px;padding:0 10px;margin-right:10px;}
  .about{padding:20px;line-height: 36px;font-size:14px;}
  .pic{padding:20px 0;}
  .pic .img{width:160px;height:120px;margin-left: 20px;}
</style>
